module.exports = __webpack_public_path__ + "img/car.6ec66f8a.svg";